/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Forms_Templates_Settings_Setclip_Section_MainInputs */

const en_forms_templates_settings_setclip_section_main = /** @type {(inputs: Forms_Templates_Settings_Setclip_Section_MainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Main`)
};

const de_forms_templates_settings_setclip_section_main = /** @type {(inputs: Forms_Templates_Settings_Setclip_Section_MainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Main`)
};

/**
* | output |
* | --- |
* | "Main" |
*
* @param {Forms_Templates_Settings_Setclip_Section_MainInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const forms_templates_settings_setclip_section_main = /** @type {((inputs?: Forms_Templates_Settings_Setclip_Section_MainInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forms_Templates_Settings_Setclip_Section_MainInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_forms_templates_settings_setclip_section_main(inputs)
	return de_forms_templates_settings_setclip_section_main(inputs)
});